import { Leading } from '@sandtech-hub-monorepo/ui-kit-site';
import homepageBanner from '../../assets/banners/homepage-banner.webp';
import { Card, cn } from '@sandtech-hub-monorepo/ui-kit';
import { RelatedProgramCard } from '@sandtech-hub-monorepo/ui-kit-site';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import React from 'react';
import { useScrollRestoration } from '@sandtech-hub-monorepo/ui-kit-site';
import { useQuery } from '@apollo/client';
import { GetViewerAvailableProgramsDocument } from '@sandtech-hub-monorepo/ehub-client';
import { ProgramsEmptyState } from './ProgramsEmptyState';

export const ProgramsPage = ({
  learningPageLink,
  programPageLink,
  paymentBanner = true,
  universityOnly = false,
  supportUrl,
}: {
  learningPageLink: string;
  programPageLink: string;
  paymentBanner: boolean;
  /**
   * Show only university programs. `availablePrograms` takes no arguments and
   * returns every program open to enrolment, both product types, so an app
   * serving only one of them has to narrow the list itself. Off by default:
   * central-hub lists everything.
   */
  universityOnly?: boolean;
  /** "Contact Support" on the empty state; defaults to the ALX help desk. */
  supportUrl?: string;
}) => {
  useScrollRestoration();
  const { data } = useQuery(GetViewerAvailableProgramsDocument, {
    fetchPolicy: 'cache-first',
  });

  const allPrograms = data?.viewer?.availablePrograms;
  const availablePrograms = universityOnly
    ? allPrograms?.filter((program) => program.isUniversityProgram)
    : allPrograms;
  const hasPrograms = availablePrograms && availablePrograms.length > 0;
  const isLoading = !data;

  return (
    <>
      <Leading
        pageName="Current Programs"
        title="Unlock Unlimited Learning"
        img={homepageBanner}
        subtitle="Find detailed information about your enrolled program here."
      />
      {isLoading ? (
        <Loading />
      ) : hasPrograms ? (
        <Card className="p-6 rounded-sm border-border-secondary max-w-screen-xl mx-auto my-8">
          <div
            className={cn(
              'grid grid-cols-1 gap-4 xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-1',
              availablePrograms.length < 3 ? 'xl:grid-cols-2' : ''
            )}
          >
            {availablePrograms.map((program) => (
              <RelatedProgramCard
                key={program.id}
                program={program}
                learningPageLink={learningPageLink}
                programPageLink={programPageLink}
              />
            ))}
          </div>
        </Card>
      ) : (
        <ProgramsEmptyState
          learningPageLink={learningPageLink}
          supportUrl={supportUrl}
        />
      )}
    </>
  );
};
